/**
 * What a person may switch on in Studio beyond All documents.
 *
 * Studio is a general creative space, and each of these serves a particular
 * kind of person — a seforim author, a musician, somebody making type — so each
 * is off until its person turns it on, and each is its own switch. The person
 * decides; nothing here is granted by anybody else, and nothing is a
 * permission: what a feature hides is still served to whoever asks for it.
 */
export const PERSON_FEATURES = ['otzar', 'songs', 'type'] as const
export type PersonFeature = (typeof PERSON_FEATURES)[number]

/** What each switch is called and what it brings back, in the reader's words. */
export const PERSON_FEATURE_COPY: Record<
  PersonFeature,
  { label: string; description: string }
> = {
  otzar: {
    label: 'Otzar',
    description:
      'The library of seforim and sources, and the sources a book cites.',
  },
  songs: {
    label: 'Songs',
    description: 'Chord sheets, and the patterns they are strummed in.',
  },
  type: {
    label: 'Type',
    description: 'The typefaces Studio sets books in, and how each is made.',
  },
}

/**
 * The features a stored list holds, in their own order. A name no longer
 * offered is dropped, so retiring a feature needs no change to anybody's row.
 */
export function personFeatures(stored: readonly string[]): PersonFeature[] {
  return PERSON_FEATURES.filter((f) => stored.includes(f))
}
